import styled from "styled-components";
import Screens from "screens";

export default styled.div`
  padding: 3vw 6vw 3vw 6vw;

  .panel {
    width: 60%;
    @media ${Screens.mobile}, ${Screens.tablet} {
      width: 90%;
    }
    margin-left: auto;
    margin-right: auto;
    .box {
      display: flex;
      flex-direction: row;
      align-items: center;
      @media ${Screens.mobile} {
        padding: 10px;
      }
      .product {
        font-size: 12px;
      }
      .visaMasterCard {
        height: 30px;
        margin-right: 20px;
      }
      .rightSection {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-left: auto;
        .title {
          margin-bottom: 0;
        }
      }
    }
    .error {
      color: red;
      margin-bottom: 15px;
    }
    .submit {
      margin-top: 30px;
    }
    .columns {
      .column {
        padding-bottom: 0;
      }
    }
    .paymentGateway {
      display: flex;
      flex-direction: row;
      margin-top: 30px;
      img {
        cursor: pointer;
      }
      .info {
        margin-top: 12px;
        margin-right: 15px;
      }
    }
  }
`;
